import React from 'react'
import './login.css'
import LanguagePicker from './LanguagePicker/LanguagePicker'
import { changeLocale } from '../../../resources/polyglot'
import { polyglot } from '../../../index'
import { Button } from '../../common/Button/Button'

export default class Login extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      email: 'test@kenetto.com',
      password: '123456',
      polyglot: undefined
    }
  }

  componentWillMount () {
    // window.myLogger.info(JSON.stringify({message: 'Login Component Rendered'}))
    const { isAuthenticated } = this.props.auth
    if (isAuthenticated()) {
      this.props.history.replace('/patients')
    }
    this.setState({
      polyglot: polyglot
    })
  }

  handleLanguageChange (value) {
    changeLocale(value).then(newValues => {
      // window.myLogger.info(JSON.stringify({message: 'Changed Language', language: value}))
      this.setState({
        polyglot: newValues
      })
    })
  }

  login () {
    const returnTo = this.props.location.state && this.props.location.state.referrer
    this.props.auth.login(returnTo)
  }

  render () {
    return <div className='container text-center'>
      <div className='col-xs-12 col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3 content login-form'>
        <div className='logo-login col-xs-12'>
          <img className='center-block' src={this.state.polyglot.t('logoData')} alt='' />
        </div>
        <Button text={this.state.polyglot.t('staticFields.commonFields.enter')} buttonType={'btn btn-default btn-lg'} type={'btn'} onClick={this.login.bind(this)} />
        <LanguagePicker handleLanguageChange={this.handleLanguageChange.bind(this)} />
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/general/Login/Login.js